import { render, staticRenderFns } from "./SoftwareNicheIcon.vue?vue&type=template&id=74df2a5c&scoped=true"
import script from "./SoftwareNicheIcon.vue?vue&type=script&lang=js"
export * from "./SoftwareNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df2a5c",
  null
  
)

export default component.exports